"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _invoiceList = require("@/api/shop/invoiceList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'invoiceEdit',
  props: {
    taxCode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      menuTypeList: [],
      loading: false,
      form: {
        id: "",
        taxCode: "",
        mcId: "",
        title: "",
        enterpriseAddress: "",
        legalPersonName: "",
        regionCode: null,
        cityName: "",
        contactsName: "",
        contactsEmail: "",
        contactsPhone: "",
        sellerTel: "",
        sellerBankName: "",
        sellerBankAccount: ""
      },
      // 表单验证规则
      rules: {
        taxCode: [{
          required: true,
          message: '请输入公司税号',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        enterpriseAddress: [{
          required: true,
          message: '请输入企业地址',
          trigger: 'blur'
        }],
        legalPersonName: [{
          required: true,
          message: '请输入法人姓名',
          trigger: 'blur'
        }],
        regionCode: [{
          required: true,
          message: '请输入地区代码',
          trigger: 'blur'
        }],
        cityName: [{
          required: true,
          message: '请输入所在城市',
          trigger: 'blur'
        }],
        contactsName: [{
          required: true,
          message: '请输入联系人姓名',
          trigger: 'blur'
        }],
        contactsPhone: [{
          required: true,
          message: '请输入联系人电话',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号码',
          trigger: 'blur'
        }],
        sellerTel: [{
          required: true,
          message: '请输入销方电话',
          trigger: 'blur'
        }],
        sellerBankName: [{
          required: true,
          message: '请输入销方开户行',
          trigger: 'blur'
        }],
        sellerBankAccount: [{
          required: true,
          message: '请输入开户行账号',
          trigger: 'blur'
        }]
      },
      businessLicenseFile: null,
      businessLicenseUrl: '',
      businessLicenseFileName: '',
      isEditMode: false
    };
  },
  created: function created() {
    if (this.taxCode) {
      this.getInvoiceListDetail();
    }
  },
  methods: {
    getInvoiceListDetail: function getInvoiceListDetail() {
      var _this = this;
      this.loading = true;
      (0, _invoiceList.getInvoiceList)({
        taxCode: this.taxCode
      }).then(function (res) {
        var data = res.records[0];
        if (data) {
          _this.form = {
            id: data.id || "",
            taxCode: data.taxCode || "",
            mcId: data.mcId || "",
            title: data.title || "",
            enterpriseAddress: data.enterpriseAddress || "",
            legalPersonName: data.legalPersonName || "",
            regionCode: data.regionCode || null,
            cityName: data.cityName || "",
            contactsName: data.contactsName || "",
            contactsEmail: data.contactsEmail || "",
            contactsPhone: data.contactsPhone || "",
            sellerTel: data.sellerTel || "",
            sellerBankName: data.sellerBankName || "",
            sellerBankAccount: data.sellerBankAccount || ""
          };
          // 如果有营业执照，则显示
          if (data.taxRegistrationCertificate) {
            _this.businessLicenseUrl = data.taxRegistrationCertificate;
            _this.isEditMode = true;
          }
        }
        _this.loading = false;
      });
    },
    handleBusinessLicenseChange: function handleBusinessLicenseChange(file) {
      this.businessLicenseFile = file.raw;
      this.businessLicenseFileName = file.name;
      this.businessLicenseUrl = URL.createObjectURL(file.raw);
    },
    beforeBusinessLicenseUpload: function beforeBusinessLicenseUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传营业执照图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传营业执照图片大小不能超过 2MB!');
        return false;
      }
      return isJPG && isLt2M;
    },
    submitForm: function submitForm() {
      var _this2 = this;
      // 表单验证
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return false;
        }
        _this2.loading = true;
        var formData = new FormData();
        if (_this2.taxCode) {
          // 编辑
          var editData = _objectSpread(_objectSpread({}, _this2.form), {}, {
            regionCode: Number(_this2.form.regionCode) || 0
          });

          // 添加 id
          if (editData.id) {
            formData.append('id', editData.id);
          }

          // 添加营业执照文件
          if (_this2.businessLicenseFile) {
            formData.append('businessLicense', _this2.businessLicenseFile);
          }

          // 添加其他表单数据
          Object.keys(editData).forEach(function (key) {
            if (editData[key] !== null && editData[key] !== '' && key !== 'id') {
              formData.append(key, editData[key]);
            }
          });
          (0, _invoiceList.updateInvoiceList)(formData).then(function (res) {
            _this2.$message.success(res.message || '修改成功');
            _this2.loading = false;
            _this2.$emit('success');
            _this2.resetForm();
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data ? error.response.data.message : '修改失败';
            _this2.$message.error(errorMsg);
            _this2.loading = false;
          });
        } else {
          // 新建
          var saveData = _objectSpread(_objectSpread({}, _this2.form), {}, {
            regionCode: Number(_this2.form.regionCode) || 0
          });

          // 添加营业执照文件
          if (_this2.businessLicenseFile) {
            formData.append('businessLicense', _this2.businessLicenseFile);
          }

          // 添加其他表单数据
          Object.keys(saveData).forEach(function (key) {
            if (saveData[key] !== null && saveData[key] !== '') {
              formData.append(key, saveData[key]);
            }
          });
          (0, _invoiceList.saveInvoiceList)(formData).then(function (res) {
            _this2.$message.success(res.message || '保存成功');
            _this2.loading = false;
            _this2.$emit('success');
            _this2.resetForm();
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data ? error.response.data.message : '保存失败';
            _this2.$message.error(errorMsg);
            _this2.loading = false;
          });
        }
      });
    },
    resetForm: function resetForm() {
      this.$refs.form.resetFields();
      this.form = {
        id: "",
        taxCode: "",
        mcId: "",
        title: "",
        enterpriseAddress: "",
        legalPersonName: "",
        regionCode: null,
        cityName: "",
        contactsName: "",
        contactsEmail: "",
        contactsPhone: "",
        sellerTel: "",
        sellerBankName: "",
        sellerBankAccount: ""
      };
      this.businessLicenseFile = null;
      this.businessLicenseUrl = '';
      this.businessLicenseFileName = '';
      this.isEditMode = false;
    },
    // 获取图片完整 URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有 url 则返回空
      if (!url) return '';

      // 如果是 blob URL（本地预览），直接返回
      if (url.startsWith('blob:')) {
        return url;
      }

      // 如果已经是完整 URL 则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      var imagePrefix = process.env.VUE_APP_IMAGE_PATH;
      if (imagePrefix) {
        // 确保前缀末尾没有斜杠，url 开头有斜杠
        var prefix = imagePrefix.endsWith('/') ? imagePrefix.slice(0, -1) : imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础 URL
      return url;
    }
  }
};